<template>
		<div class="home-page">
		<Header></Header>
      <div class="mission-content ac crfff">
        <div class="" @click="back" style="margin-top:40px;width: 80px;height:80px;text-align: center;display: flex;align-items: center;justify-content: center;">
          <img width="50" src="../../static/images/back.png" />
        </div>
        <div class="fs50 mt50">{{$t('BgFusion')}}</div>
        <div class="css-1asaykn mt50">
          <div class="css-1asaykn mt20">
            <img width="450" src="../../static/images/Smart_Blend.jpg" />
          </div>
          <div class="css-12nj5ib mt30">
            <div style="">{{$t('BgFusion_tips')}}</div>
          </div>
          <div id="controlBox" class="oneImageInput mt50">
            <div class="oneImageInput-content" >
              <input type="file" @change="(e) => convertToBase64_v2(e, 1)" class="file" accept="image/*" mutiple="mutiple">
              <div class="imageInputBox">
                <div class="uploadBox uploadIcon">
                  <img style="width:60%;" v-if="imageBase64_1" :src="imageBase64_1" />
                  <div class="" v-else>
                    <img width="80" src="../../static/images/transparent.png">
                    <div class="label"> {{$t('Upload_bg')}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="controlBox" class="oneImageInput mt50">
            <div class="oneImageInput-content" >
              <input type="file" @change="(e) => convertToBase64_v2(e, 2)" class="file" accept="image/*" mutiple="mutiple">
              <div class="imageInputBox">
                <div class="uploadBox uploadIcon">
                  <img style="width:60%;" v-if="imageBase64_2" :src="imageBase64_2" />
                  <div class="" v-else>
                    <img width="80" src="../../static/images/transparent.png">
                    <div class="label"> {{$t('Upload_pt')}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div class="ac mt30">
          <button style="width: calc(100% - 100px);" @click="uploadImage" class="button"><strong>{{$t('Generate')}}</strong></button>
      </div>
<!--      <div class="flex mt50" style="justify-content: space-around;width: 90%;margin: 0 auto;">-->
<!--        <button class="btn btn-blue">{{$t('ChancesLeft')}}: {{score}}</button>-->
<!--        <button class="button" @click="goPurchaseChances" style="padding:8px 10px;width: auto;font-size: 24px;"><strong>{{$t('BuyChances')}}</strong><img style="margin-left: 10px;" width="30" src="../../static/images/buy.png"></button>-->
<!--      </div>-->
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
              <div class="image ac" v-if="imageShow">
                <div class="" style="font-size:28px;margin-bottom: 20px;">{{$t('downTips1')}}</div>
               <img v-if="isShowResult==1" :src="detail.url" style="width:90%;" />
               <img v-if="isShowResult==2" :src="detail.original_url" style="width:90%;" />

               <div class="tab mt20">
                  <span @click="getResult(1)" :class="{'active':isShowResult==1}">{{$t('Result')}}</span>
                  <span @click="getResult(2)" :class="{'active':isShowResult==2}">{{$t('Original')}}</span>
               </div>
                <div class="img-tools">
                  <div class="ac disflex mt30">
                   <div class="input-item">
                     <div class="input-item2" v-if="isShowResult==1">
                       <input class="input" disabled v-model="detail.url"  type="" placeholder="">
                       <img id="copycode" :data-clipboard-text="detail.url" @click="copy" v-if="detail.url" style="margin-left: 10px;" width="90" src="../../static/images/Copy.png" />
                     </div>
                     <div class="input-item2" v-if="isShowResult==2">
                       <input class="input" disabled v-model="detail.original_url"  type="" placeholder="">
                       <img id="copycode" :data-clipboard-text="detail.original_url" @click="copy" v-if="detail.original_url" style="margin-left: 10px;" width="90" src="../../static/images/Copy.png" />
                     </div>
                   </div>

                   <!-- <button class="button fw7" style="width: 100%;" id="copycode" :data-clipboard-text="detail.url" @click="copy" v-if="detail.url">{{$t('copyLink')}}<img style="margin-left: 10px;" width="28" src="../../static/images/copy1.png" /></button> -->
                  </div>
                </div>
              </div>
          </div>
      </Dialog>
      <Dialog ref="processDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
        <div class="alert-modal ac" slot="mdBox" >
          <div class="close" @click="closeProcessDialog" style="text-align: right;margin:10px auto;font-size: 50px;    margin-right: -20px;">
            <img width="70" src="../../static/images/close.png" />
          </div>
          <div class="fs33 mt50 ac">{{processMsg}}</div>
          <button class="button mt30" @click="closeProcessDialog">{{$t('OK')}}</button>
        </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
			detail:{},
			isShow:false,
			value:50,
			imageShow:false,
			imageBase64: null,
      imageBase64_1: null,
      imageBase64_2: null,
			imageTpye:'',
      imageTpye_1:'',
      imageTpye_2:'',
			withScratch:false,
			isImgModel:false,
			isImage:true,
      score:0,
      isShowResult:1,
      processMsg:"",
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
      getResult(type){
        this.isShowResult = type
      },
      copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
		  back(){
      this.$router.go(-1);
		},
		  getHome(){
			let that =this;
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
        });
			})
		},
      getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
      convertToBase64(event, index) {
      const file = event.target.files[0];
      if (!file) return;
      if (index === 1) {
        this.imageTpye_1 =this.getCharactersAfter(file.type, '/');
      } else if (index === 2) {
        this.imageTpye_2 = this.getCharactersAfter(file.type, '/');
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        if (index === 1) {
          this.imageBase64_1 = e.target.result;
        } else if (index === 2) {
          this.imageBase64_2 = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
      convertToBase64_v2(event, index) {
        let that =this;
        const file = event.target.files[0];
        if (!file) return;
        // 原始大小（单位：KB）
        const originSizeKB = (file.size / 1024).toFixed(2);
        console.log("原始文件大小:", originSizeKB, "KB");
        // 1. 文件大小限制（5MB）
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
          that.$refs.processDialog.showMaskFun();
          that.processMsg = this.$t('pic_size_limit')
          event.target.value = '';
          return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            // 2. 缩放尺寸
            const maxWidth = 800;
            const maxHeight = 800;
            let { width, height } = img;
            if (width > height) {
              if (width > maxWidth) {
                height *= maxWidth / width;
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width *= maxHeight / height;
                height = maxHeight;
              }
            }
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            // 3. PNG 自动转 JPEG
            let outputType = file.type.toLowerCase() === 'image/png' ? 'image/jpeg' : file.type;
            // 4. 压缩导出（JPEG 质量 0.7）
            // this.imageBase64 = canvas.toDataURL(outputType, 0.7);
            if (index === 1) {
              this.imageBase64_1 = canvas.toDataURL(outputType, 0.7);
            } else if (index === 2) {
              this.imageBase64_2 = canvas.toDataURL(outputType, 0.7);
            }
            // 5. 设置上传类型
            // this.imageTpye = outputType.split('/')[1]; // e.g. "jpeg"
            if (index === 1) {
              this.imageTpye_1 =outputType.split('/')[1];
            } else if (index === 2) {
              this.imageTpye_2 = outputType.split('/')[1];
            }
            // 计算压缩后的大小
            // const compressedSize = this.base64Size(this.imageBase64);
            let compressedSize = 0;
            if (index === 1) {
               compressedSize = this.base64Size(this.imageBase64_1);
            } else if (index === 2) {
               compressedSize = this.base64Size(this.imageBase64_2);
            }
            console.log("压缩后文件大小:", (compressedSize / 1024).toFixed(2), "KB");
          };
        };

        reader.readAsDataURL(file);
        event.target.value = '';
      },
      uploadImage() {
      let that = this
      if(!that.imageBase64_1 || !that.imageBase64_2){
        that.$utils.alertText(that.$t('uploadTips'),100);
        return;
      }
      let data ={
        image_bg:{
         image:{
           type:that.imageTpye_1,
           content:that.imageBase64_1
         }
        },
        image_fg:{
         image:{
           type:that.imageTpye_2,
           content:that.imageBase64_2
         }
        },

      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/background_fusion',data,r =>{
        if(r.code==0){
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,100);
          return;
        }
      	that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          that.getHome()
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
      	});
      })
    },
      getImage(){
       const link = document.createElement('a')
       link.style.display = 'none'
       link.href = this.detail.url
       console.log(link.href)
       // link.target = '_blank'
       link.setAttribute('download', '文件名称')
       document.body.appendChild(link)
       link.click()
        window.open(this.detail.url, '_blank')

    },
      closeTmgDialog(){
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
      goPurchaseChances(){
      this.$router.push({path:'/purchaseChances'})
    },
      base64Size(base64) {
        let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
        let eqIndex = str.indexOf('=');
        if (eqIndex > 0) {
          str = str.substring(0, eqIndex); // 去掉填充字符
        }
        let length = str.length;
        return length * 3 / 4; // 得到字节数
      },
      closeProcessDialog(){
        this.processMsg = ""
        this.$refs.processDialog.closeMask();
      },
	}
}
</script>
<style>
  input.iosSwitch {
      position: relative;
      -webkit-appearance: none;
      -moz-appearance: none;
      outline: none;
      width: 80px;
      height: 40px;
      background-color: #fff;
      border: 1px solid #d9dadc;
      border-radius: 50px;
      box-shadow: inset -20px 0 0 0 #fff;
      margin-right: 15px;
  }

  input.iosSwitch:after {
      content: "";
      position: absolute;
      top: 1px;
      left: 1px;
      background: 0 0;
      width: 46px;
      height: 36px;
      border-radius: 50%;
      box-shadow: 2px 4px 6px rgba(0,0,0,.2);
  }

  input.iosSwitch:checked {
      box-shadow: inset 20px 0 0 0 #0062ff;
      border-color: #0062ff
  }

  input.iosSwitch:checked:after {
      left: 20px;
      box-shadow: -2px 4px 3px rgba(0,0,0,.05);
  }
  .imageInputBox{padding: 90px 20px;min-height: 30px;}
  #activeFormBox input.file,#controlBox input.file {
    width: 100%;
    min-height:300px;
    opacity: 0;
    overflow: hidden;
    z-index: 10;
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 0;
}
.oneImageInput{background: #020e5bb8;border-radius: 14px;box-shadow: 0 0 20px #49c1ff;border: 2px solid #fff;}
.oneImageInput-content{position: relative;min-height: 300px;}
  .withScratchBox{box-shadow: 0 0 20px #49c1ff;padding:40px;border-top: 2px solid #fff;}
  .uploadIcon .label{color:#5562af;margin-top: 20px;}

</style>



// WEBPACK FOOTER //
// src/page/bgFusion.vue